import React from 'react'
import Intro from './Intro'
import Services from './Services'
import Benifits from './Benifits'
import WhereWeUse from './WherWeUse'
import Awards from './Awards'
import Contact from '../../../ContactForm/ContactUs'
import { Helmet } from 'react-helmet';

const Office24by7 = () => {

  return (
    <div>
      <Helmet>
        <title>PT KCS | Office24by7 – Digital Workplace & Remote Work Solutions Indonesia</title>
        <meta 
          name="description" 
          content="PT KCS provides Office24by7 in Indonesia, a complete digital workplace solution enabling seamless remote work, CRM automation, collaboration, and optimized business productivity." 
        />
        <meta 
          name="keywords" 
          content="PT KCS, PT KCS Tech Indonesia, Office24by7 Jakarta, digital workplace solutions Indonesia, remote work software, collaboration tools, business automation, secure communication, workflow optimization, remote workforce management" 
        />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS" />
      </Helmet>


            <Intro />
      <Services />
      <Benifits />
      <WhereWeUse />
      <Awards />
      <Contact/>
    </div>
  )
}

export default Office24by7
